import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import usersReducer from '../features/users/usersSlice';
import userDetailsReducer from '../features/userDetails/userDetailsSlice';
import appReducer from '../features/app/appSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    userDetails: userDetailsReducer,
    app: appReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
